module.exports = __webpack_public_path__ + "img/403.03555d09.svg";